export const domain = "mervatsreams.smartiniaclient.com";
// ragda
// mervet
